import { render, staticRenderFns } from "./ButtonIconText.vue?vue&type=template&id=56b3cfe0"
import script from "./ButtonIconText.vue?vue&type=script&lang=js"
export * from "./ButtonIconText.vue?vue&type=script&lang=js"
import style0 from "./ButtonIconText.vue?vue&type=style&index=0&id=56b3cfe0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports